import React from 'react';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { Button } from '../ui/Button';
import { COAFilters as Filters, AccountType } from '../../types/coa.types';
import { SearchIcon, XIcon } from 'lucide-react';
interface COAFiltersProps {
  filters: Filters;
  onFilterChange: (filters: Filters) => void;
  onReset: () => void;
}
export function COAFilters({
  filters,
  onFilterChange,
  onReset
}: COAFiltersProps) {
  const accountTypes: AccountType[] = ['Asset', 'Liability', 'Equity', 'Expense', 'Income'];
  return <div className="bg-white p-4 rounded-lg border space-y-4" data-id="element-86">
      <div className="flex items-center justify-between" data-id="element-87">
        <h3 className="text-sm font-semibold text-gray-900 flex items-center gap-2" data-id="element-88">
          <SearchIcon className="w-4 h-4" data-id="element-89" />
          Search Filters
        </h3>
        <Button variant="ghost" size="sm" onClick={onReset} data-id="element-90">
          <XIcon className="w-4 h-4 mr-1" data-id="element-91" />
          Clear
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-92">
        <Input label="Account Code" placeholder="Search by code..." value={filters.accountCode || ''} onChange={e => onFilterChange({
        ...filters,
        accountCode: e.target.value
      })} data-id="element-93" />

        <Input label="Account Name" placeholder="Search by name..." value={filters.accountName || ''} onChange={e => onFilterChange({
        ...filters,
        accountName: e.target.value
      })} data-id="element-94" />

        <Select label="Account Type" options={accountTypes.map(t => ({
        value: t,
        label: t
      }))} value={filters.accountType || ''} onChange={e => onFilterChange({
        ...filters,
        accountType: e.target.value as AccountType
      })} data-id="element-95" />

        <Select label="Branch" options={[{
        value: 'branch1',
        label: 'Hargeisa Branch'
      }, {
        value: 'branch2',
        label: 'Mogadishu Branch'
      }]} value={filters.branchId || ''} onChange={e => onFilterChange({
        ...filters,
        branchId: e.target.value
      })} data-id="element-96" />

        <Select label="Project" options={[{
        value: 'proj1',
        label: 'Infrastructure Project'
      }, {
        value: 'proj2',
        label: 'Education Initiative'
      }]} value={filters.projectId || ''} onChange={e => onFilterChange({
        ...filters,
        projectId: e.target.value
      })} data-id="element-97" />

        <Input label="Bank Account No" placeholder="Search by account no..." value={filters.bankAccountNo || ''} onChange={e => onFilterChange({
        ...filters,
        bankAccountNo: e.target.value
      })} data-id="element-98" />
      </div>
    </div>;
}